<div class="tj">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Jegyek tanáronként</ion-card-title>
      <ion-card-subtitle>
        A tanárok által beírt értékelések a rögzítő tanár szerint. Tanár nélkül összesítő (ki hány jegyet adott, hány
        tantárgyból, mikor utoljára) – egy sorra kattintva a tanár jegyei tantárgyanként, darabszámmal és átlaggal.
        A stornózott jegy nem látszik. Az átlag az évközi érdemjegyekből számol, az értékelés módjának súlyával; a
        „nem írta” (–) és a szöveges értékelés nem számít bele.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="sor">
        <ion-input type="date" label="Ettől" label-placement="stacked" [(ngModel)]="tol" (ionChange)="toltes()"></ion-input>
        <ion-input type="date" label="Eddig" label-placement="stacked" [(ngModel)]="ig" (ionChange)="toltes()"></ion-input>
        <div class="valaszto">
          <label class="cimke">Tanár</label>
          <ng-select appendTo="body" [items]="tanarok" bindLabel="cimke" bindValue="adid" [(ngModel)]="tanar"
                     (change)="valaszt($event?.adid || null)" [clearable]="true"
                     [notFoundText]="'Nincs találat'" placeholder="Mind (összesítő) – keresés névre"></ng-select>
        </div>
        <ng-container *ngIf="tanar && adat">
          <ion-select label="Tantárgy" label-placement="stacked" interface="popover" [(ngModel)]="tantargy" (ionChange)="szures()">
            <ion-select-option value="">Mind</ion-select-option>
            <ion-select-option *ngFor="let t of tantargyak" [value]="t.id">{{ t.nev }} ({{ t.db }})</ion-select-option>
          </ion-select>
          <ion-button fill="outline" size="small" (click)="pdf()" [disabled]="!ossz.db">
            <ion-icon slot="start" name="document-text-outline"></ion-icon>PDF
          </ion-button>
          <ion-button fill="outline" size="small" (click)="csv()" [disabled]="!ossz.db">
            <ion-icon slot="start" name="download-outline"></ion-icon>CSV
          </ion-button>
        </ng-container>
      </div>

      <div *ngIf="betolt" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>
      <p class="hiba" *ngIf="hiba">{{ hiba }}</p>

      <!-- Összesítő: minden tanár az időszakban -->
      <ng-container *ngIf="!tanar && !betolt && !hiba">
        <p class="halvany">
          {{ tol }} – {{ ig }} · <b>{{ tanarok.length }}</b> tanár, összesen <b>{{ osszesJegy }}</b> jegy
          <span class="rend"> · rendezés:
            <a [class.aktiv]="rendezes === 'nev'" (click)="rendezes = 'nev'">név</a> /
            <a [class.aktiv]="rendezes === 'jegyek'" (click)="rendezes = 'jegyek'">jegyszám</a>
          </span>
        </p>
        <p class="halvany" *ngIf="!tanarok.length">Az időszakban nincs beírt jegy.</p>
        <table class="lista" *ngIf="tanarok.length">
          <thead><tr><th>Tanár</th><th class="sz">Jegyek</th><th class="sz">Tantárgyak</th><th class="sz">Osztályok</th><th>Utolsó jegy</th></tr></thead>
          <tbody>
            <tr *ngFor="let t of osszesito" class="kattinthato" (click)="valaszt(t.adid)">
              <td><b>{{ t.nev }}</b><span class="halvany adid"> {{ t.adid }}</span></td>
              <td class="sz">{{ t.jegyek }}</td>
              <td class="sz">{{ t.tantargyak }}</td>
              <td class="sz">{{ t.osztalyok }}</td>
              <td>{{ t.utolso || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <!-- Egy tanár jegyei -->
      <ng-container *ngIf="tanar && adat && !betolt && !hiba">
        <p class="halvany">
          <a class="vissza" (click)="valaszt(null)">‹ összesítő</a> ·
          <b>{{ adat.tanar?.nev }}</b> · {{ adat.idoszak?.tol }} – {{ adat.idoszak?.ig }} ·
          <b>{{ ossz.db }}</b> jegy · átlag: <b>{{ szam(ossz.atlag) }}</b>
          <span *ngIf="ossz.szazalek != null"> · százalékos átlag: <b>{{ szam(ossz.szazalek, 1) }}%</b></span>
        </p>
        <p class="halvany" *ngIf="!ossz.db">A tanárnak nincs beírt jegye az időszakban.</p>

        <table class="lista osszeg" *ngIf="csoportok.length > 1">
          <thead><tr><th>Tantárgy</th><th>Osztály / csoport</th><th class="sz">Jegyek</th><th class="sz">Tanulók</th><th class="sz">Átlag</th><th class="sz">% átlag</th><th>Utolsó jegy</th></tr></thead>
          <tbody>
            <tr *ngFor="let t of csoportok" class="kattinthato" (click)="tantargy = t.id; szures()">
              <td><b>{{ t.nev }}</b></td><td class="halvany">{{ t.egysegek }}</td>
              <td class="sz">{{ t.db }}</td><td class="sz">{{ t.tanulok }}</td>
              <td class="sz">{{ szam(t.atlag) }}</td><td class="sz">{{ t.szazalek == null ? '—' : szam(t.szazalek, 1) + '%' }}</td>
              <td>{{ t.utolso }}</td>
            </tr>
          </tbody>
        </table>

        <div class="tantargy" *ngFor="let t of csoportok">
          <h3>{{ t.nev }}
            <span class="halvany">· {{ t.db }} jegy, {{ t.tanulok }} tanuló · átlag: {{ szam(t.atlag) }}<ng-container *ngIf="t.szazalek != null"> · {{ szam(t.szazalek, 1) }}%</ng-container></span>
          </h3>
          <table class="lista">
            <thead><tr><th>Dátum</th><th>Tanuló</th><th>Osztály / csoport</th><th class="kozep">Jegy</th><th>Értékelés módja</th><th class="sz">Súly</th><th>Téma / megjegyzés</th></tr></thead>
            <tbody>
              <tr *ngFor="let j of t.jegyek">
                <td class="nowrap">{{ j.datum }}</td>
                <td>{{ j.tanulo }}</td>
                <td>{{ egyseg(j) }}</td>
                <td class="kozep"><span class="jegy" [ngClass]="jegyOsztaly(j)">{{ jegySzoveg(j) }}</span></td>
                <td>{{ modSzoveg(j) }}</td>
                <td class="sz">{{ j.suly == null ? '' : (j.suly / 100) + '×' }}</td>
                <td class="halvany">{{ j.tema }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
